enum ApplicationStatus {
    Pending = "pending",
    Approved = "approved",
    Rejected = "rejected",
    MissingDocuments = "missing_documents",
    VisaApproved = "visa_approved",
    VisaRejected = "visa_rejected"
}

export { ApplicationStatus };